import { render, staticRenderFns } from "./RecordXTimeBeforeDueAtReminderNotification.vue?vue&type=template&id=b6f5900c&scoped=true&"
import script from "./RecordXTimeBeforeDueAtReminderNotification.vue?vue&type=script&lang=js&"
export * from "./RecordXTimeBeforeDueAtReminderNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordXTimeBeforeDueAtReminderNotification.vue?vue&type=style&index=0&id=b6f5900c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f5900c",
  null
  
)

export default component.exports